import React from 'react';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import QueryStringService from '../../services/queryStringService.js';
import ExportService from '../../services/exportService.js';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import * as consts from '../../models/consts.js'

export default class IDSExportButton extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.exportService = new ExportService();

        this.state = {
            exportingIDS: false
        };

        this.exportToExcel = this.exportToExcel.bind(this);
    }

    exportToExcel() {

        if (this.props.exportAllowed !== undefined && this.props.exportAllowed.toLowerCase() === 'no') {
            toast.info("Not possible to export IDS file");
            console.log("Not possible to export IDS file");
            return;
        }

        this.setState({
            exportingIDS: true
        });

        this.exportService.getIDSExport(this.props.orderlineid, (IDSData) => {

            try {

                if (!IDSData) {
                    console.log("No data while exporting IDS file");
                    return;
                }
                let file = new Blob([IDSData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const fileExtension = '.xlsx';
                const fileName = 'PoP-IDS-Export-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension;

                const ua = window.navigator.userAgent;
                if (ua.match(/Edge/)) {
                    window.navigator.msSaveBlob(file, filename);
                } else {
                    FileSaver.saveAs(file, fileName);
                }

                this.setState({ exportingIDS: false });
            }
            catch (ex) {
                this.setState({ exportingIDS: false });
                console.error("Error while downloading and saving the IDS export to the browser.", ex);
                toast.error(<div>Something went wrong while trying to export from IDS!<br />Try again or contact support.</div>);
            }

        }, (error) => {
            this.setState({ exportingIDS: false });

            console.error("Error while exporting IDS file", error);
            toast.error(<div>Something went wrong while trying to export from IDS!<br/>Try again or contact support.</div>);
        });
    }

    render() {
        let colorClass = 'btn-play';
        if (this.props.campaignType !== undefined && this.props.campaignType.toLowerCase() === 'posting') {
            colorClass = 'btn-posting';
        }
        let showLoadingIcon = this.props.showLoadingIcon !== undefined && this.props.showLoadingIcon;

        return (
            <div>
                <button disabled={!this.props.allowIDSExport} className={'btn ' + colorClass + ' hidden-print'}
                    style={{ minWidth: showLoadingIcon && "140px" }}
                    target='_blank'
                    onClick={() => { this.exportToExcel() }}>
                    IDS result export{this.country !== consts.Countries.dk ? '*' : ''}
                    {this.state.exportingIDS && showLoadingIcon &&
                        <FontAwesomeIcon icon={faSpinner} spin size="xs" fixedWidth />
                    }
                </button>
            </div>
        );
    }
}